<template>
  <div id="privacy" class="legal-section">
    <section class="hero is-medium is-primary null-bg">
      <h1>{{ $t("PRIVACY_POLICY_TITLE") }}</h1>
      <h2>{{ $t("PRIVACY_POLICY_SUBTITLE") }}</h2>
      <p v-html="parseLegalTextToHtml()" />
      <br />
      <p v-html="parseMessageToHtml('PRIVACY_POLICY_UPDATE_DATE')" />
    </section>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  methods: {
    parseMessageToHtml(key) {
      return this.$t(key).replace(/\n/g, "<br />");
    },
    parseLegalTextToHtml() {
      const urlWord = "www.isglobal.org";
      const urlTag =
        '<a href="' + urlWord + '" target="_blank">' + urlWord + "</a>";
      const cookiesWord = this.$t("COOKIE_POLICY");
      const cookiesTag =
        '<a href="' +
        this.$t("COOKIE_POLICY_URL") +
        '" target="_blank">' +
        cookiesWord +
        "</a>";
      const mailWord = "lopd@isglobal.org";
      const mailRegex = /lopd@isglobal.org/gi;
      const mailTag =
        '<a href="mailto:' +
        mailWord +
        '" target="_blank">' +
        mailWord +
        "</a>";
      return this.parseMessageToHtml("PRIVACY_POLICY_TEXT")
        .replace(urlWord, urlTag)
        .replace(cookiesWord, cookiesTag)
        .replace(mailRegex, mailTag);
    }
  }
};
</script>
